<template>
    <div>
        <div v-if="column.type === 'bool'">
            <Icon v-if="[false, 'false', 0, '0'].includes(getItemValue(column))" :icon="icons.inactive" color="warning" :center="column.align === 'center'"/>
            <Icon v-else-if="[true, 'true', 1, '1'].includes(getItemValue(column))" :icon="icons.active" color="success" :center="column.align === 'center'"/>
            <span v-else>-</span>
        </div>
        <div v-else-if="column.type === 'bool_revert'">
            <Icon v-if="[false, 'false', 0, '0'].includes(getItemValue(column))" :icon="icons.active" color="success" :center="column.align === 'center'"/>
            <Icon v-else-if="[true, 'true', 1, '1'].includes(getItemValue(column))" :icon="icons.inactive" color="warning" :center="column.align === 'center'"/>
            <span v-else>-</span>
        </div>
        <div v-else-if="column.type === 'date'">
            <dynamic-date :date="getItemValue(column)" short/>
        </div>
        <div v-else-if="column.type === 'datetime'">
            <dynamic-date :date="getItemValue(column)" short time/>
        </div>
        <div v-else-if="column.type === 'daterange'">
            <dynamic-date-range :start="getItemValue(column)" :end="getItemValue(column, 'end_value')"/>
        </div>
        <div v-else-if="column.type === 'datetimerange'">
            <dynamic-date-range :start="getItemValue(column)" :end="getItemValue(column, 'end_value')" time/>
        </div>
        <div v-else-if="column.type === 'html'" v-html="getItemValue(column)"/>
        <div v-else-if="column.type === 'amount'"
             :class="{'text-success': getItemValue(column) > 0, 'text-error': getItemValue(column) < 0, 'table-text-line': column.nowrap, 'whitespace-pre-wrap': column.wrap}">
            <span v-if="![null, undefined, column.default].includes(getItemValue(column))">{{ toEuro(getItemValue(column), true, false, false) }}</span>
            <span v-else>-</span>
        </div>
        <div v-else-if="column.formatter" :class="{'table-text-line': column.nowrap, 'whitespace-pre-wrap': column.wrap}">{{ column.formatter({item: item, parent: parent, reduced: reduced}) }}</div>
        <div v-else :class="{'table-text-line': column.nowrap, 'whitespace-pre-wrap': column.wrap}">{{ getItemValue(column) }}</div>
    </div>
</template>

<script>
import {mdiCheck, mdiClose} from "@mdi/js";
    import {getPropValue} from "@spoferan/spoferan-ts-core";
    import {toEuro} from "@spoferan/spoferan-ts-core";

    export default {
        name: 'TableBodyCell',

        props: {
            // The column (header) definition whose value is displayed in the cell
            column: {
                type: Object,
                required: true
            },

            // The item being displayed in the cell
            item: {
                type: Object,
                required: true
            },

            // The parent data when the item is a displayed as a child
            parent: {
                type: Object,
                default: null
            },

            // Whether the cell shall display a short version of its value
            reduced: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                icons: {
                    active: mdiCheck,
                    inactive: mdiClose,
                },
            }
        },

        methods: {
            toEuro,

            /**
             * Gets the value of the item for the specified column.
             * Supports '.'-syntax for nested props.
             *
             * @param column
             * @param valueKey
             * @returns {*}
             */
            getItemValue(column, valueKey = 'value') {
                if (['value', 'end_value'].includes(valueKey) && column.formatter) {
                    return column.formatter({item: this.item, parent: this.parent, reduced: this.reduced, prop: column[valueKey]});
                }

                const value = getPropValue(this.item, column[valueKey])

                return ![null, undefined].includes(value) ? value : column.default;
            }
        }

    }
</script>